var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('v-icon',{staticClass:"icon-4xl margin-sides-10",attrs:{"color":"secondary lighten-2"}},[_vm._v(_vm._s(_vm.icon))]),_c('v-layout',{staticClass:"font-15",attrs:{"column":""}},[_c('span',{staticClass:"font-400"},[_vm._v(_vm._s(_vm.caption))]),_c('span',{staticClass:"font-600"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }